import * as CollapsiblePrimitive from "@radix-ui/react-collapsible";
import { ComponentPropsWithoutRef, ElementRef, forwardRef } from "react";

import { cn } from "@/lib/utils";

const HookCollapsibleContent = forwardRef<
  ElementRef<typeof CollapsiblePrimitive.CollapsibleContent>,
  ComponentPropsWithoutRef<typeof CollapsiblePrimitive.CollapsibleContent>
>(({ className, ...props }, ref) => (
  <CollapsiblePrimitive.CollapsibleContent
    ref={ref}
    className={cn(
      "overflow-hidden data-[state=closed]:animate-hook-collapsible-up data-[state=open]:animate-hook-collapsible-down",
      className,
    )}
    {...props}
  />
));

HookCollapsibleContent.displayName = CollapsiblePrimitive.CollapsibleContent.displayName;

export default HookCollapsibleContent;
